import Link from "next/link"
import cn from "classnames"

import { useGetSeoList } from "@hooks"

import styles from "./SeoLinks.module.scss"

const SeoLinks = ({ title, list, more, less, emptyMessage, type }) => {
  const { linkList, hasNoLinks, showAll, setShowAll } = useGetSeoList(
    list,
    type
  )

  return (
    <>
      {hasNoLinks ? null : (
        <div className={styles.breedListWrapper}>
          <div className={styles.article}>
            <div className={styles.articleContent}>
              <h2 className={styles.title}> {title} </h2>
              {hasNoLinks && <p className={styles.noDogs}>{emptyMessage}</p>}
              <div className={styles.data}>
                {linkList?.map(({ linkText, count, link, id }) => (
                  <Link
                    key={id}
                    href={link}
                    className={cn(
                      styles.listItem,
                      !count ? styles.grey : styles.link
                    )}
                  >
                    <p>{linkText}</p>
                  </Link>
                ))}
              </div>
            </div>
            <div
              onClick={() => setShowAll((curr) => !curr)}
              className={styles.view}
            >
              <p>
                {showAll ? less : more}{" "}
                <span>
                  <img
                    width="11px"
                    height="6px"
                    alt={showAll ? "Black up arrow" : "Black down arrow"}
                    src={
                      showAll
                        ? "/search/arrow-top-black.svg"
                        : "/search/arrow-down-black.svg"
                    }
                  />
                </span>
              </p>
            </div>
          </div>
          {/* This is a fallback for users with JavaScript disabled */}
          <noscript>
            {linkList?.map(({ name, count }, i) => (
              <div
                key={i}
                className={cn(
                  styles.listItem,
                  !count ? styles.grey : styles.link
                )}
              >
                <p>{name}</p>
              </div>
            ))}
          </noscript>
        </div>
      )}
    </>
  )
}

export default SeoLinks
